import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'custom-shimmer',
  templateUrl: './custom-shimmer.component.html',
  styleUrls: ['./custom-shimmer.component.scss'],
  imports: [CommonModule]
})
export class CustomShimmerComponent {
  readonly _repeat = input<number>(3);
  readonly multiStrokeWithImage = input<boolean>(true);
  readonly singleStroke = input<boolean>(false);

  readonly repeat = computed(() => {
    return Array.from(Array(this._repeat()).keys());
  });
}

